var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 27,
    viewBox: "0 0 15 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57219 27H10.0267V14.9368H14.0374L14.8396 10.0652H10.0267V6.35344C10.0267 4.96154 11.3904 4.18826 12.6738 4.18826H15V0.167206L10.7487 0.0125501C6.73797 -0.219434 4.49198 2.79636 4.49198 6.43077V10.0652H0V14.9368H4.57219V27Z",
    fill: "#F39422"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb_icon.886e68cd8a09c2987b0f14554135f495.svg";
export { ForwardRef as ReactComponent };